import isObjectLike from "lodash/isObjectLike";

export const isNumericString = (str: string): boolean => /^\d+$/.test(str);

export const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

function escapeStringForRegex(text: string) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export function getSearchRegExp(str: string, regex: string) {
  return new RegExp(escapeStringForRegex(str), regex);
}

export const stringify = (value: any): string => {
  return isObjectLike(value) ? JSON.stringify(value) : String(value);
};

export const isSubstring = (value: any, substring: string) => {
  if (!value) return false;

  return stringify(value).toLowerCase().includes(substring.toLowerCase());
};

/**
 * The article to put in front of a word in user-facing copy. Spelling-based, so
 * it gets the sounded-out exceptions wrong ("an Uber", "a hour") — fine for the
 * resource and brand names it runs on, not a general-purpose grammar rule.
 */
export const indefiniteArticle = (word: string): string =>
  /^[aeiou]/i.test(word) ? "an" : "a";

export const toTitleCase = (str: string) => {
  const trimmed = str.trim();
  return trimmed.slice(0, 1).toUpperCase() + trimmed.slice(1);
};
